import script from "./FaqsView.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqsView.vue?vue&type=script&setup=true&lang=js"

import "./FaqsView.vue?vue&type=style&index=0&id=62eecebc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62eecebc"]])

export default __exports__